import { StoreType } from 'features/my-store/types/StoreType';
import { NotificationListItemType } from 'features/notification/types/NotificationType';
import { filterByStores } from 'features/notification/utils/filters';

/**
 * 指定された店舗で、未読のお知らせがあるかチェックする
 * @param notifications 全てのお知らせ
 * @param stores フィルタリングする店舗の配列
 * @returns 未読があればtrue、なければfalse
 */
export const hasUnread = (
  notifications: NotificationListItemType[],
  stores: StoreType[] = []
): boolean => {
  const targets =
    stores.length > 0 ? filterByStores(notifications, stores) : notifications;
  return targets.some((notification) => !notification.read);
};
